import global_axios from '../funciones_globales/interaccionapi';

export const cargarPermisoBoton=(codBoton, usuario)=> {
    return new Promise((resolve, reject) => {
        global_axios.get('/accionesporusuario/'+codBoton+'/'+usuario)
	    .then((response)=>{
            var valor;
            if(response.data===null){
                valor = {display: 'none'};//NO CUMPLE RESTRICCIÓN USUARIO
            }else{
                valor = {display: 'block'};//CUMPLE RESTRICCIÓN USUARIO
            }
            resolve(valor);
        })
        .catch((err)=>{
            reject('Error al cargar acciones desde API: ' + err);
        });
    });
}

export const validarAccesoATransaccion = (codigoTransaccion, username, perfilId) =>{
    return new Promise((resolve, reject) => {
        global_axios.post('/accionesporusuario', {codigoTransaccion, username, perfilId})
            .then((response)=>{
                resolve(response.data);
            })
            .catch(err => {
                reject(err.response?err.response.data.msg : err);
            });
    });
}